<script setup>
import {isIzsWorker} from "../../utils";
import {reverseUrl} from "../../../../url";
import {pgettext} from "../../../../utils/translate";
import AllPersonsList from "../../dashboard/patientListItems/AllPersonsList.vue";
import {useQuery} from "@vue/apollo-composable";
import {useLastResult} from "../../../../graphql/composable";
import {useSearch} from "../../../../search";
import {IzsPatientListQuery} from "@/graphql/queries/hpo/patients.graphql";
import {computed, ref, useTemplateRef} from "vue";
import Counters from "./Counters.vue";
import {mdiPhoneOutline} from "@mdi/js";
import CallModal from "../call/CallModal.vue";

const props = defineProps({
  hpo: {
    type: Object,
    required: true
  },
  member: {
    type: Object,
    required: true
  },
  patientCounts: {
    type: Object,
    required: true
  },
  patientCountsLoading: {
    type: Boolean,
    required: true
  },
  hpoPassword: {
    type: String,
    required: true
  },
  countries: {
    type: Array,
    required: true
  },
  mobileView: {
    type: Boolean,
    required: true,
  },
  chipProperties: {
    type: Object,
    required: true
  },
  personsTrackerTimestamp: {
    type: Object,
    required: true
  },
})

const showCallModal = ref(false)

// Persons Query
const personsQueryVariables = computed(() => ({
  updateTimestamp: props.personsTrackerTimestamp,
  hpoId: props.hpo.id
}));
const {result: patientListResult, loading: patientListLoading} = useQuery(IzsPatientListQuery, personsQueryVariables)
const patientList = useLastResult(patientListResult, [], data => data.izsPatientList);

const {query, searchResultsOrAllItems: filteredPatientList} = useSearch(
  patientList, ['firstName', 'lastName', 'birthNumber', 'birthYear', 'note'], ['tic']
);

const anyLoading = computed(() => {
  return props.patientCountsLoading || patientListLoading.value
})

</script>

<template>
  <v-container fluid class="pa-0">
    <v-row dense v-if="patientCounts && !isIzsWorker(member.role)" class="mb-6">
      <v-col cols="12" class="d-flex justify-center ga-3 flex-wrap">
        <Counters :hpo-id="hpo.id"
                  :member="member"
                  :loading="patientCountsLoading"
                  :patientCounts="patientCounts"/>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" md="4" offset-md="4">
        <v-btn
          block
          :prepend-icon="mdiPhoneOutline"
          :text="pgettext('label', 'New Call')"
          size="x-large"
          @click="showCallModal = true"
        ></v-btn>
      </v-col>
    </v-row>
  </v-container>

  <CallModal v-if="showCallModal"
             :hpo="hpo"
             :member="member"
             :countries="countries"
             @close="showCallModal = false"/>
</template>
